// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Zj","title":"_j","nav":"ak","flexCell":"bk","facetLink":"ck"};